import { render } from "./CookieView.vue?vue&type=template&id=a72f0280&scoped=true"
const script = {}

import "./CookieView.vue?vue&type=style&index=0&id=a72f0280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72f0280"]])

export default __exports__